// extracted by mini-css-extract-plugin
module.exports = {"course_card__buy_button":"styles_course_card__buy_button__1QSCs","course_card__secondary":"styles_course_card__secondary__3DopU"};